import { render, staticRenderFns } from "./LegacyGaugeChartWidget.vue?vue&type=template&id=e21fe754&"
import script from "./LegacyGaugeChartWidget.vue?vue&type=script&lang=js&"
export * from "./LegacyGaugeChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports